import { getSelectedNode } from 'owa-mail-folder-forest-store';
export default function isGroupNodeSelected(groupId, treeType) {
    var selectedNode = getSelectedNode();
    return (selectedNode &&
        selectedNode.id &&
        selectedNode.treeType == treeType &&
        groupId.toLowerCase() == selectedNode.id.toLowerCase());
}
//# sourceMappingURL=isGroupNodeSelected.js.map